import { useEffect } from "react";
import { useData } from "data/data-provider";
import { useLocation } from "react-router-dom";
import DesignARouter from "routers/DesignARouter";
import DesignBRouter from "routers/DesignBRouter";

function App() {
  const { loadingCompanyDetails, ourCompany } = useData();
  const location = useLocation();

  useEffect(() => {
    const historyKey = "app_route_history";
    const currentPath = location.pathname + location.search;
    let history: string[] = [];

    try {
      const rawHistory = sessionStorage.getItem(historyKey);
      history = rawHistory ? (JSON.parse(rawHistory) as string[]) : [];
    } catch {
      history = [];
    }

    if (history[history.length - 1] !== currentPath) {
      history.push(currentPath);
    }

    sessionStorage.setItem(historyKey, JSON.stringify(history.slice(-30)));
  }, [location.pathname, location.search]);

  return (
    <div className="bg-bg-color">
      {loadingCompanyDetails ? (
        <div className="flex justify-center items-center col-span-full min-h-[100vh]">
          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
        </div>
      ) : (
        // <div className="text-base text-text-color bg-bg-color">
        //   {ourCompany?.default_template === "design2" ? (
        //     <DesignBRouter />
        //   ) : (
        <DesignARouter />
        //   )}
        // </div>
      )}
    </div>
  );
}

export default App;
